import Amplify from 'aws-amplify';
import { environment } from 'environment';

export const configureAmplify = () => {
  const state = (process.env.REACT_APP_ENV || 'production') as keyof typeof environment;
  const env = environment[state];
  Amplify.configure(env.aws);
};
